export default "__VITE_ASSET__DajH5Dor__"